import environment from '../environment';
import StoresControl from './StoresControl';

export class CompetitorsControl extends StoresControl {
    constructor () {
        const options = {
            name: 'Competitors',
            context: 'LAYER_COMPETITORS',
            stores: environment.get('CONFIG.COMPETITORS')
        };

        super(options);
    }

    static getInstance () {
        if (!CompetitorsControl._instance) {
            CompetitorsControl._instance = new CompetitorsControl();
        }

        return CompetitorsControl._instance;
    }
}

export default CompetitorsControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/CompetitorsControl.js